<template>
  <div>
    <button class="month-trigger bg-white btn input-tall rounded border border-black-30" type="button"
      @click="$refs.drawer.show()">
      <div class="flex items-center font-normal">
        <span class="flex-1 text-left pl-1 truncate">{{ selectedMonthDisplay }}</span>

        <svg width="24" height="24">
          <use xlink:href="/img/sprite.svg#ic_chevron-down"></use>
        </svg>
      </div>
    </button>
    <bottom-drawer ref="drawer" @backdrop-clicked="$refs.drawer.hide()">
      <div class="flex flex-col items-center">
        <header class="picker-container flex-none flex items-center h-16">
          <span class="font-medium flex-1 text-left fs-20">Select month</span>
          <button type="button" @click="$refs.drawer.hide()">
            <svg width="24" height="24">
              <use xlink:href="/img/sprite.svg#ic_close"></use>
            </svg>
          </button>
        </header>
        <hr class="border border-black-30 w-full" />
        <div class="picker-container picker-body flex-1 overflow-y-auto pb-6">
          <div v-for="year in years" :key="year">
            <div class="pt-8 pb-4 font-medium text-center">{{ year }}</div>
            <section class="month-grid">
              <button v-for="(monthName, month) in months" :key="monthName"
                type="button"
                class="p-3 cursor-pointer"
                :class="{
                  'is-disabled': isInThePast(year, month),
                  'is-selected': (month - 1) == selectedMonth && year == selectedYear
                }"
                @click="selectMonth(year, month)">
                {{ monthName }}
              </button>
            </section>
          </div>
        </div>
        <hr class="border border-black-30 w-full" />
        <footer class="picker-container flex-none py-4 h-20 flex items-center">
          <button type="button" class="btn btn-secondary btn-outlined input-tall flex-1 mr-2"
            @click="$refs.drawer.hide()">
            Cancel
          </button>
          <button type="button" class="btn btn-secondary input-tall flex-1 ml-2"
            @click="handleSubmit">
            Select month
          </button>
        </footer>
      </div>
    </bottom-drawer>
  </div>
</template>

<script>
import BottomDrawer from '../../components/core/BottomDrawer'

export default {
  components: {
    BottomDrawer
  },
  props: ['value'],
  data () {
    return {
      selectedTime: this.value
    }
  },
  computed: {
    years () {
      const thisYear = moment().year()

      return [thisYear, thisYear + 1, thisYear + 2]
    },
    months () {
      return {
        1: 'Jan',
        2: 'Feb',
        3: 'Mar',
        4: 'Apr',
        5: 'May',
        6: 'Jun',
        7: 'Jul',
        8: 'Aug',
        9: 'Sep',
        10: 'Oct',
        11: 'Nov',
        12: 'Dec'
      }
    },
    selectedMonthDisplay () {
      return moment(this.value).format('MMM YYYY')
    },
    temporaryMonthDisplay () {
      return moment(this.selectedTime).format('MMM YYYY')
    },
    selectedYear () {
      return moment(this.selectedTime).year()
    },
    selectedMonth () {
      return moment(this.selectedTime).month()
    }
  },
  methods: {
    isInThePast (year, month) {
      const today = moment()
      const thisYear = today.year()

      if (year < thisYear) {
        return true
      }

      if (year > thisYear) {
        return false
      }

      const thisMonth = today.month() + 1
      return month < thisMonth
    },
    selectMonth (year, month) {
      const monthFormat = month < 10 ? `0${month}` : month
      const newMoment = moment(`${year}-${monthFormat}-01`).format('YYYY-MM-DD')

      this.selectedTime = newMoment
    },
    handleSubmit () {
      this.$emit('input', this.selectedTime)
      this.$refs.drawer.hide()
    }
  }
}
</script>

<style scoped>
.picker-container {
  width: 320px;
  max-height: 60vh;
}

.is-selected {
  background: var(--secondary);
  color: white;
  border-radius: 0.25em;
}

@media (max-width: 600px) {
  .picker-container {
    width: 100%;
    padding-left: 24px;
    padding-right: 24px;
  }

  .picker-body {
    max-width: 320px;
  }

  .month-trigger {
    border: 1px solid #dcdcdc;
  }
}
</style>
